import { z } from 'zod';
const versionedIdentifier = z.string().min(5).max(160)
    .regex(/^[a-z][a-z0-9-]*(?:\.[a-z0-9-]+)+\.v[1-9][0-9]*$/);
export const mitigationAssistantContextCapability = 'mitigation.assistant-context.v1';
export const mitigationAssistantContextProviderId = mitigationAssistantContextCapability;
export const mitigationAssistantContextSlot = 'platform.server.optional-context';
export const mitigationAssistantContextRequestSchema = z.strictObject({
    requestId: z.string().uuid(),
    subjectType: z.literal('projects.project'),
    subjectId: z.string().uuid().nullable(),
    query: z.string().trim().max(160).nullable().optional(),
    requestedCapabilities: z.array(versionedIdentifier).min(1).max(50),
    redactionProfile: z.string().min(2).max(80).regex(/^[a-z][a-z0-9-]*$/),
    maxFacts: z.number().int().min(1).max(500),
});
export const mitigationAssistantContextFactSchema = z.strictObject({
    factType: z.literal('mitigation.project-drying-summary'),
    value: z.record(z.string().min(1).max(120), z.unknown()),
    sourceRevision: z.string().min(1).max(160),
    observedAt: z.string().datetime({ offset: true }),
    redactedFields: z.array(z.string().min(1).max(512)).max(100),
});
export const mitigationAssistantContextResultSchema = z.strictObject({
    providerId: z.literal(mitigationAssistantContextProviderId),
    providerModuleId: z.literal('mitigation'),
    capability: z.literal(mitigationAssistantContextCapability),
    facts: z.array(mitigationAssistantContextFactSchema).max(1),
    unavailableReason: z.enum([
        'not-entitled',
        'not-enabled',
        'permission-denied',
        'provider-failed',
    ]).nullable(),
});
//# sourceMappingURL=mitigation-assistant-context.contract.js.map